// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__29Da5","head":"ProcedureTableInfo_head__Hcr70"};